if (!customElements.get('custom-subscription')) {
  customElements.define(
    'custom-subscription',
    class CustomSubscription extends HTMLElement {
      constructor() {
        super();
        this.subscriptionData = {};
        this.eventListeners = new Map();

        this.step1 = this.querySelector('.js-subscription-step-box');
        this.step2 = this.querySelectorAll('.js-subscription-step-name');
        this.step3 = this.querySelector('.js-step-size');
        // this.step4 = this.querySelector('.js-subscription-step-breed');
        this.step5 = this.querySelector('.js-step-dob');
        this.step6 = this.querySelector('.js-step-allergies');
        this.step7 = this.querySelector('.js-step-email');
        this.step8 = this.querySelector('.js-step-plan');
        this.step9 = this.querySelector('.js-step-extra');
        this.allSteps = this.querySelectorAll('.js-subscription-item');

        this.bundleCollectionSize = '';
        this._bundleCollectionSize = '';
        this.planVariantId = '';
        this.extraProductId = '';
        this.sellingPlanId = '';
        this.addGift = "false";
        this.showAllergyURLParam = false;
        this.selectedExtraProductIds = new Set();

this.urlObject = new URL(window.location.href);

// remove internal utm_id if present (does not touch utm_source/medium/campaign)
this.urlObject.searchParams.delete('utm_id');

if (window.Shopify.designMode != true) {
  this.urlObject.searchParams.set('step', 1);
  // do not force utm_id
  // this.urlObject.searchParams.set('utm_id', 'subscription');

  if (
    this.step1?.querySelector('.js-box-type.box-active') &&
    this.step1.querySelector('.js-box-type.box-active').getAttribute('data-current-sub')
  ) {
    let step1ParamKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';
    this.urlObject.searchParams.set(
      step1ParamKey,
      this.step1.querySelector('.js-box-type.box-active').getAttribute('data-current-sub')
    );
  }

  history.pushState(null, '', this.urlObject);
}


        this.subscriptionSteps();
        this.currentQuiz = this.step1?.querySelector('.js-box-type.box-active')?.getAttribute('data-url-param');
      }

      handleProgressBar(step) {
        let progressBar = this.querySelector('.js-progress-bar-width');
        let totalBlocks = progressBar.getAttribute('data-block-count');
        let widthPercent = (100 * step) / totalBlocks;
        progressBar.style.width = `${widthPercent}%`;

        let progressText = this.querySelector('.js-progress-text');
        progressText.innerHTML = `Step ${step}/${totalBlocks}`;
      }

      showStep(stepNumber) {
        this.allSteps.forEach((step) => {
          step.classList.add('hide');
          step.classList.remove('active_div');
        });

        const nextStep = this.querySelector(`.js-sub-step--${stepNumber}`);
        if (nextStep) {
          nextStep.classList.remove('hide');
          nextStep.classList.add("active_div");
        }

        if (nextStep.classList.contains("js-step-size")) {
          window.setGridHeight('.item_boxs.custom_image .box_item');
        }

        if (nextStep.classList.contains("js-subscription-step-box")) {
          window.setGridHeight('.js-box-type');
        }

        if (nextStep.classList.contains("js-step-plan")) {
          window.setGridHeight('.js-subscription-plan .subscription-step-plan-product');
        }

        if (nextStep.classList.contains("js-step-allergies")) {
          this.showAllergyURLParam = true;
          let selectedAllergies = nextStep.querySelectorAll('.js-allergy-checkbox');
          let paramKey = nextStep.getAttribute('data-url-tracking-key') || "allergies";

          let selectedAllergiesValue = '';

          if (selectedAllergies.length > 0) {
            selectedAllergiesValue = Array.from(selectedAllergies)
              .filter(allergy => allergy.checked)
              .map(allergy => allergy.value)
              .join(', ');
          }
          this.updateURLParam(paramKey, selectedAllergiesValue);
        }
      }

      // ✅ FIXED: async method; uses only buttons inside the current step;
      // submits email (if this is the email step) BEFORE advancing.
      async addNavigationHandlers(stepElement, propKey) {
        const isMobile = window.matchMedia('(max-width: 699px)').matches;
        const nextBtn = stepElement?.querySelector('.js-next-button');
        const prevBtn = stepElement?.querySelector('.js-prev-button');
        const skipBtn = isMobile
          ? stepElement?.querySelector('.js-mob-skip-button')
          : stepElement?.querySelector('.js-skip-button');

        // Helper to compute the next step for THIS element
        const getNextStepNumber = () => {
          const local = stepElement?.querySelector('.js-next-button')?.getAttribute('data-next');
          if (local) return local;

          const active = this.querySelector('.js-subscription-item.active_div');
          if (active) {
            const m = active.className.match(/js-sub-step--(\d+)/);
            if (m) return String(parseInt(m[1], 10) + 1);
          }
          return null;
        };

        // --- NEXT ---
        if (nextBtn) {
          if (this.eventListeners.has(nextBtn)) {
            nextBtn.removeEventListener('click', this.eventListeners.get(nextBtn));
          }

          const handleNextClick = async () => {
            const nextStepNumber = getNextStepNumber();
            if (!nextStepNumber) return;

            // Email step: submit before advancing
            if (stepElement.classList.contains('js-step-email')) {
              try {
                await Promise.race([
                  this.submitSubscribeEmail(),
                  new Promise(res => setTimeout(res, 700)),
                ]);
                console.log('[Email] submitted before next step');
              } catch (e) {
                console.warn('[Email submit] failed', e);
              }
            }

            this.showStep(nextStepNumber);
            this.handleProgressBar(parseInt(nextStepNumber, 10));
            this.updateURLParamStep(nextStepNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };

          nextBtn.addEventListener('click', handleNextClick);
          this.eventListeners.set(nextBtn, handleNextClick);
        }

        // --- PREV ---
        if (prevBtn) {
          if (this.eventListeners.has(prevBtn)) {
            prevBtn.removeEventListener('click', this.eventListeners.get(prevBtn));
          }

          const handlePrevClick = () => {
            const prevStepNumber = prevBtn.getAttribute('data-previous');
            if (!prevStepNumber) return;

            this.showStep(prevStepNumber);
            this.handleProgressBar(parseInt(prevStepNumber, 10));
            this.updateURLParamStep(prevStepNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };

          prevBtn.addEventListener('click', handlePrevClick);
          this.eventListeners.set(prevBtn, handlePrevClick);
        }

        // --- SKIP (always goes forward) ---
        if (skipBtn) {
          if (this.eventListeners.has(skipBtn)) {
            skipBtn.removeEventListener('click', this.eventListeners.get(skipBtn));
          }

          const handleSkipClick = async () => {
            // If the skip button lives on the email step and the email field is valid,
            // we’ll also submit before advancing (optional; keep if you like)
            if (stepElement.classList.contains('js-step-email')) {
              try {
                await Promise.race([
                  this.submitSubscribeEmail(),
                  new Promise(res => setTimeout(res, 700)),
                ]);
              } catch (e) {
                console.warn('[Email submit on skip] failed', e);
              }
            }

            const nextStepNumber = getNextStepNumber();
            if (!nextStepNumber) return;

            if (propKey) this.subscriptionData[propKey] = "";
            this.showStep(nextStepNumber);
            this.handleProgressBar(parseInt(nextStepNumber, 10));
            this.updateURLParamStep(nextStepNumber);
            this.removeFieldValues(stepElement);

            const paramKey = skipBtn.getAttribute('data-url-tracking-key');
            if (paramKey) this.updateURLParam(paramKey, null);

            window.scrollTo({ top: 0, behavior: 'smooth' });
          };

          skipBtn.addEventListener('click', handleSkipClick);
          this.eventListeners.set(skipBtn, handleSkipClick);
        }
      }

      removeFieldValues(stepElement) {
        if (stepElement.classList.contains('js-subscription-step-name')) {
          let inputQuizField = stepElement.querySelector('.js-input-quiz-field');
          let nextStepBtn = stepElement.querySelector('.js-next-button');
          if (inputQuizField) inputQuizField.value = "";
          if (nextStepBtn) nextStepBtn.disabled = true;
        }
        if (stepElement.classList.contains('js-step-dob')) {
          let birthDay = stepElement.querySelector('.js-dog-birthday');
          let birthMonth = stepElement.querySelector('.js-dog-birthmonth');
          let birthYear = stepElement.querySelector('.js-dog-birthyear');
          let nxtStepBtn = stepElement.querySelector('.js-next-button');
          if (birthDay) birthDay.value = "Day";
          if (birthMonth) birthMonth.value = "Month";
          if (birthYear) birthYear.value = "Year";
          if (nxtStepBtn) nxtStepBtn.disabled = true;
        }
      }

      updateURLParam(key, value) {
        if (window.Shopify.designMode == true) return;
        if (key && value) {
          this.urlObject.searchParams.set(key, value);
        }
        else if (key && (value === "" || value === null)) {
          this.urlObject.searchParams.delete(key);
        }
        history.pushState(null, '', this.urlObject);
      }

      updateURLParamStep(stepNumber) {
        if (window.Shopify.designMode == true) return;
        this.urlObject.searchParams.set('step', stepNumber);
        history.pushState(null, '', this.urlObject);
      }

      subscriptionSteps() {
        this.initialRedirection();
        this.boxType();
        this.quizInputField();
        this.boxSize();
        // this.breedType();
        this.dateOfBirth();
        this.dogfAllergies();
        this.emailField();
        this.updatePlans();
        this.selectExtra();
      }

      set bundleCollectionSize(value) {
        if (this._bundleCollectionSize !== value) {
          this._bundleCollectionSize = value;
          this.updatePlans();
        }
      }

      get bundleCollectionSize() {
        return this._bundleCollectionSize;
      }

      initialRedirection() {
        const storedValue = sessionStorage.getItem("theme:subscription-selection");

        if (storedValue) {
          const selectedBox = this.step1.querySelector(`[data-current-sub="${storedValue}"]`);
          const nextStepBtn = this.step1.querySelector('.js-next-button');
          let paramKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';
          let paramValue = selectedBox.getAttribute('data-url-tracking-value') || selectedBox.getAttribute('data-current-sub');

          if (selectedBox && nextStepBtn) {
            selectedBox.classList.add('box-active');
            const boxes = this.step1.querySelectorAll('.js-box-type');
            boxes.forEach(box => {
              if (box !== selectedBox) box.classList.remove('box-active');
            });
            this.updateURLParam(paramKey, paramValue);
            nextStepBtn.disabled = false;
            this.addNavigationHandlers(this.step1);
            // nextStepBtn.click();
            sessionStorage.removeItem("theme:subscription-selection");
          }
        }
      }

      boxType() {
        if (!this.step1) return;

        let boxes = this.step1.querySelectorAll('.js-box-type');
        let nextStepBtn = this.step1.querySelector('.js-next-button');
        let urlKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';

        if (!boxes.length || !nextStepBtn) return;

        if (boxes.length > 0) {
          boxes.forEach(box => {
            box.addEventListener('click', (e) => {
              if (box.getAttribute("href") == "#") {
                e.preventDefault();
                let paramValue = box.getAttribute('data-url-tracking-value') || box.getAttribute('data-current-sub');
                this.updateURLParam(urlKey, paramValue);
              }
              else {
                let currentSelection = box.getAttribute('data-current-sub');
                sessionStorage.setItem("theme:subscription-selection", currentSelection);
              }
              boxes.forEach(b => b.classList.remove('box-active'));
              box.classList.add('box-active');

              let anyActive = Array.from(boxes).some(box => box.classList.contains('box-active'));
              nextStepBtn.disabled = !anyActive;
            })
          })
        }

        this.addNavigationHandlers(this.step1);
        window.setGridHeight('.js-box-type');
      }

      quizInputField() {
        if (this.step2.length < 1) return;

        this.step2.forEach((currStep) => {
          let inputQuizField = currStep.querySelector('.js-input-quiz-field');
          let lineItemProp = currStep.getAttribute('data-line-item-property') || 'Quiz field';
          let nextStepBtn = currStep.querySelector('.js-next-button');
          let addToBoxBtn = currStep.querySelector('.js-add-to-box');
          let urlKey = currStep.getAttribute('data-url-tracking-key') || 'quiz_field';

          if (!inputQuizField || (!nextStepBtn && !addToBoxBtn)) return;

          this.eventListeners.forEach((listener, el) => {
            if (!document.contains(el)) {
              el.removeEventListener('input', listener);
              this.eventListeners.delete(el);
            }
          });

          if (this.eventListeners.has(inputQuizField)) {
            inputQuizField.removeEventListener('input', this.eventListeners.get(inputQuizField));
          }

          const handleInput = () => {
            let quizValue = inputQuizField.value.trim();
            if (nextStepBtn) nextStepBtn.disabled = !quizValue;
            if (addToBoxBtn) addToBoxBtn.disabled = !quizValue;
            this.subscriptionData[`${lineItemProp}`] = quizValue;
            if (quizValue !== "") {
              this.updateURLParam(urlKey, quizValue);
            }
            else {
              this.updateURLParam(urlKey, null);
            }
          };

          inputQuizField.addEventListener('input', handleInput);
          this.eventListeners.set(inputQuizField, handleInput);

          this.addNavigationHandlers(currStep, lineItemProp);
          if (addToBoxBtn) {
            this.addSubscriptionToCart(addToBoxBtn);
          }
        })
      }

      boxSize() {
        if (!this.step3) return;

        let sizeBoxes = this.step3.querySelectorAll('.js-bundle-size');
        let nextStepBtn = this.step3.querySelector('.js-next-button');
        let subscriptionPlans = this.step8?.querySelectorAll('.js-subscription-plan') || [];
        let step9Btn = this.step8?.querySelector('.js-next-button');
        let addToBoxBtn = this.step3.querySelector('.js-add-to-box');
        let paramKey = this.step3.getAttribute('data-url-tracking-key') || "size";

        if (!sizeBoxes.length || (!nextStepBtn && !addToBoxBtn)) return;

        this.eventListeners.forEach((listener, el) => {
          if (!document.contains(el)) {
            el.removeEventListener('click', listener);
            this.eventListeners.delete(el);
          }
        });

        sizeBoxes.forEach((box) => {
          if (this.eventListeners.has(box)) {
            box.removeEventListener('click', this.eventListeners.get(box));
          }

          const handleClick = () => {
            sizeBoxes.forEach((boxItem) => boxItem.classList.remove('size-box-active'));
            box.classList.add('size-box-active');

            let boxSizeValue = box.querySelector('.js-box-size-value');
            this.bundleCollectionSize = box.getAttribute('data-bundle-size');

            let boxName = boxSizeValue?.querySelector('.box_title')?.innerHTML || '';
            let boxWeight = boxSizeValue?.querySelector('.box_subtext')?.innerHTML || '';
            if (boxWeight) {
              this.subscriptionData["Size"] = `${boxName} | ${boxWeight}`.trim();
            }
            else {
              this.subscriptionData["Size"] = `${boxName}`.trim();
            }
            let paramValue = box.getAttribute('data-url-tracking-value');
            this.updateURLParam(paramKey, paramValue);

            let anyActive = Array.from(sizeBoxes).some(box => box.classList.contains('size-box-active'));
            if (nextStepBtn) nextStepBtn.disabled = !anyActive;
            if (addToBoxBtn) addToBoxBtn.disabled = !anyActive;

            subscriptionPlans.forEach((plan) => {
              plan.classList.remove('plan-selected');
            });

            if (step9Btn && !step9Btn.disabled) step9Btn.disabled = true;
          };

          box.addEventListener('click', handleClick);
          this.eventListeners.set(box, handleClick);
        });

        this.addNavigationHandlers(this.step3);
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      dateOfBirth() {
        if (!this.step5) return;

        let dobDayField = this.step5.querySelector('.js-dog-birthday');
        let dobMonthField = this.step5.querySelector('.js-dog-birthmonth');
        let dobYearField = this.step5.querySelector('.js-dog-birthyear');
        let nextStepBtn = this.step5.querySelector('.js-next-button');
        let addToBoxBtn = this.step5.querySelector('.js-add-to-box');
        let paramKey = this.step5.getAttribute('data-url-tracking-key');

        if (!dobDayField || !dobMonthField || !dobYearField || (!nextStepBtn && !addToBoxBtn)) return;

        const validateDOB = () => {
          let dobDay = dobDayField.value.trim();
          let dobMonth = dobMonthField.value.trim();
          let dobYear = dobYearField.value.trim();

          if (dobDay !== 'Day' && dobMonth !== 'Month' && dobYear !== 'Year') {
            this.subscriptionData["Cat's Dob"] = `${dobDay}-${dobMonth}-${dobYear}`;
            if (nextStepBtn) nextStepBtn.removeAttribute('disabled');
            this.updateURLParam(paramKey, `${dobDay}-${dobMonth}-${dobYear}`);
          } else {
            if (nextStepBtn) nextStepBtn.setAttribute('disabled', 'true');
            this.updateURLParam(paramKey, null);
          }
        };

        [dobDayField, dobMonthField, dobYearField].forEach(field => {
          if (this.eventListeners.has(field)) {
            field.removeEventListener('change', this.eventListeners.get(field));
          }

          field.addEventListener('change', validateDOB);
          this.eventListeners.set(field, validateDOB);
        });

        validateDOB();

        this.addNavigationHandlers(this.step5, "Cat's Dob");
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      dogfAllergies() {
        if (!this.step6) return;

        let allergyCheckboxes = this.step6.querySelectorAll('.js-allergy-checkbox');
        let nextStepBtn = this.step6.querySelector('.js-next-button');
        let addToBoxBtn = this.step6.querySelector('.js-add-to-box');
        let paramKey = this.step6.getAttribute('data-url-tracking-key') || "allergies";

        if (!allergyCheckboxes.length || (!nextStepBtn && !addToBoxBtn)) return;

        let handleAllergyChange = (event) => {
          let changedCheckbox = event ? event.target : null;

          let noAllergyCheckbox = this.step6.querySelector('.js-no-allergy-checkbox');

          if (changedCheckbox && changedCheckbox.classList.contains('js-no-allergy-checkbox')) {
            if (changedCheckbox.checked) {
              allergyCheckboxes.forEach(checkbox => {
                if (!checkbox.classList.contains('js-no-allergy-checkbox')) {
                  checkbox.checked = false;
                }
              });
            }
          } else if (changedCheckbox) {
            if (changedCheckbox.checked && noAllergyCheckbox) {
              noAllergyCheckbox.checked = false;
            }
          }

          let selectedAllergies = Array.from(allergyCheckboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value)
            .join(', ');

          this.subscriptionData["Allergies"] = selectedAllergies;
          if (this.showAllergyURLParam) {
            this.updateURLParam(paramKey, selectedAllergies);
          }
        };

        allergyCheckboxes.forEach(checkbox => {
          if (this.eventListeners.has(checkbox)) {
            checkbox.removeEventListener('change', this.eventListeners.get(checkbox));
          }

          checkbox.addEventListener('change', handleAllergyChange);
          this.eventListeners.set(checkbox, handleAllergyChange);
        });

        handleAllergyChange();

        this.addNavigationHandlers(this.step6);

        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      emailField() {
        if (!this.step7) return;

        let emailField = this.step7.querySelector('.js-subscription-email-field');
        let newsletterCheckbox = this.step7.querySelector('.js-newsletter-checkbox');
        let nextStepBtn = this.step7.querySelector('.js-next-button');
        let addToBoxBtn = this.step7.querySelector('.js-add-to-box');
        let paramKey = this.step7.getAttribute('data-url-tracking-key') || "email";

        if (!emailField || !newsletterCheckbox || (!nextStepBtn && !addToBoxBtn)) return;

        const handleEmailInput = () => {
          let email = emailField.value.trim();
          let isValid = this.validateEmail(email);
          if (nextStepBtn) nextStepBtn.disabled = !isValid;
          if (addToBoxBtn) addToBoxBtn.disabled = !isValid;
          this.subscriptionData["Email"] = email;
          if (isValid) {
            this.updateURLParam(paramKey, email);
          }
          else {
            this.updateURLParam(paramKey, null);
          }
        };

        this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        const handleNewsletterChange = () => {
          this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        };

        if (!this.eventListeners.has(emailField)) {
          emailField.addEventListener('input', handleEmailInput);
          this.eventListeners.set(emailField, handleEmailInput);
        }

        if (!this.eventListeners.has(newsletterCheckbox)) {
          newsletterCheckbox.addEventListener('change', handleNewsletterChange);
          this.eventListeners.set(newsletterCheckbox, handleNewsletterChange);
        }

        this.addNavigationHandlers(this.step7);

        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      validateEmail(email) {
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

submitSubscribeEmail() {
  // Email capture is now handled by the Liquid form in step-email.liquid
  console.log('[Email] submit handled by Shopify customer form');
  return Promise.resolve();
}

      updatePlans() {
        if (!this.step8) return;

        let subscriptionPlans = this.step8.querySelectorAll('.js-subscription-plan');
        let popularPlanBtn = this.step8.querySelector('.js-popular-plan-btn');
        let nextStepBtn = this.step8.querySelector('.js-next-button');
        let addToBoxBtn = this.step8.querySelector('.js-add-to-box');
        let paramKey = this.step8.getAttribute('data-url-tracking-key') || "plan";

        if (!subscriptionPlans.length || (!nextStepBtn && !addToBoxBtn)) return;

        subscriptionPlans.forEach((plan) => {
          let planCollectionSize = plan.getAttribute('data-size');

          if (planCollectionSize !== this.bundleCollectionSize) {
            plan.classList.add('hide');
          } else {
            plan.classList.remove('hide');
          }

          if (this.eventListeners.has(plan)) {
            plan.removeEventListener('click', this.eventListeners.get(plan));
          }

          const handlePlanClick = () => {
            let planId = plan.getAttribute('data-plan-id');
            let sellingPlan = plan.getAttribute('data-selling-plan');
            this.planVariantId = planId;
            this.sellingPlanId = sellingPlan;

            subscriptionPlans.forEach((subPlan) => subPlan.classList.remove('plan-selected'));
            plan.classList.add('plan-selected');

            let isGiftAdded = plan.getAttribute('data-gift-available');
            this.addGift = isGiftAdded;

            let anyActive = Array.from(subscriptionPlans).some(plan => plan.classList.contains('plan-selected'));
            if (nextStepBtn) nextStepBtn.disabled = !anyActive;
            if (addToBoxBtn) addToBoxBtn.disabled = !anyActive;
            let paramValue = plan.getAttribute('data-plan-name');
            if (paramKey && paramValue) this.updateURLParam(paramKey, paramValue);
          };

          plan.addEventListener('click', handlePlanClick);
          this.eventListeners.set(plan, handlePlanClick);
        });

        this.addNavigationHandlers(this.step8);
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      selectExtra() {
        if (!this.step9) return;

        let extraProducts = this.step9.querySelectorAll('.js-extra-product-container');
        let nextStepBtn = this.step9.querySelector('.js-next-button');
        let addToBoxBtn = this.step9.querySelector('.js-add-to-box');
        let paramKey = this.step9.getAttribute('data-url-tracking-key') || "extra_product";

        if (extraProducts.length > 0) {
          extraProducts.forEach((product) => {
            const handleProductClick = () => {
              let productId = product.getAttribute('data-extra-product-id');
              let productName = product.getAttribute('data-extra-product-name');
              let productSellingPlan = product.getAttribute('data-selling-plan') || '';

              let key = productSellingPlan && productSellingPlan.trim() !== '' ? `${productId}:${productSellingPlan}` : productId;

              if (this.selectedExtraProductIds.has(key)) {
                product.classList.remove('selected-extra-product');
                this.selectedExtraProductIds.delete(key);
              } else {
                product.classList.add('selected-extra-product');
                this.selectedExtraProductIds.add(key);
              }

              let selectedExtraProducts = Array.from(extraProducts)
                .filter(box => {
                  let pid = box.getAttribute('data-extra-product-id');
                  let plan = box.getAttribute('data-selling-plan') || '';
                  let key = plan.trim() !== '' ? `${pid}:${plan}` : pid;
                  return this.selectedExtraProductIds.has(key);
                })
                .map(box => box.getAttribute('data-extra-product-name'))
                .join(', ');

              let anyActive = Array.from(extraProducts).some(box => box.classList.contains('selected-extra-product'));
              if (nextStepBtn) nextStepBtn.disabled = !anyActive;
              if (addToBoxBtn) {
                addToBoxBtn.innerHTML = anyActive ? "CHECKOUT" : "SKIP AND CHECKOUT";
              }
              this.updateURLParam(paramKey, selectedExtraProducts);
            };

            if (this.eventListeners.has(product)) {
              product.removeEventListener('click', this.eventListeners.get(product));
            }

            product.addEventListener('click', handleProductClick);
            this.eventListeners.set(product, handleProductClick);
          });
        }

        this.addNavigationHandlers(this.step9);
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      async getCartData() {
        let cart = await fetch('/cart.js').then(res => res.json());
        return cart;
      }

      addSubscriptionToCart(addToBoxBtn) {
        if (this.eventListeners.has(addToBoxBtn)) {
          addToBoxBtn.removeEventListener('click', this.eventListeners.get(addToBoxBtn));
        }

        const handleClick = async () => {
          let cartData = await this.getCartData();

          this.subscriptionData['_subscription_product'] = 'true';
          this.subscriptionData['_gift_eligible'] = this.addGift == "true" ? 'true' : 'false';
          this.subscriptionData['_gift_type'] = 'regular';

          let items = [
            {
              'id': this.planVariantId,
              'quantity': 1,
              'selling_plan': this.sellingPlanId,
              'properties': this.subscriptionData
            }
          ];

          if (this.selectedExtraProductIds && this.selectedExtraProductIds.size > 0) {
            this.selectedExtraProductIds.forEach((id) => {
              if (id.includes(':')) {
                let [productId, sellingPlan] = id.split(':');
                items.push({ id: productId, quantity: 1, selling_plan: sellingPlan });
              } else {
                items.push({ id: id, quantity: 1 });
              }
            });
          }

          let giftProduct = this.querySelector('.js-sub-free-gift');
          if (giftProduct && this.addGift == "true") {
            let giftProductId = parseInt(giftProduct.getAttribute('data-gift-id'), 10);
            let isGiftAlreadyInCart = cartData.items.some(item => item.variant_id === giftProductId);
            if (giftProductId && !isGiftAlreadyInCart) {
              items.push({
                'id': giftProductId,
                'quantity': 1,
                'properties': {
                  '_subscription_free_gift': 'true',
                  '_free_gift_type': 'regular'
                }
              });
            }
          }

          const addItems = (list) => fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: list })
          });

          try {
            let response = await addItems(items);

            if (!response.ok) {
              const err = await response.json().catch(() => ({}));
              console.error('Cart add failed:', err.description || err);
              const withoutGift = items.filter(i => !(i.properties && i.properties._subscription_free_gift));
              if (withoutGift.length !== items.length) {
                response = await addItems(withoutGift);
              }
            }

            if (response.ok) {
              const isFrenchSitecart =
                window.location.hostname.includes("fr.") ||
                window.location.pathname.toLowerCase().startsWith("/fr");
              window.location.href = isFrenchSitecart ? "/fr/cart" : "/cart";
            } else {
              alert('Something went wrong adding your box to the cart. Please try again or contact us.');
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
          }

          this.submitSubscribeEmail();
        };

        addToBoxBtn.addEventListener('click', handleClick);
        this.eventListeners.set(addToBoxBtn, handleClick);
      }
    }
  );
}